<template>
  <span class="tag-badge">
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'TagBadge',
  props: {
    label: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>

.tag-badge {
  display: inline-block;
  padding: 4px 10px; /* 👈 más compacto */
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  color: #4d9ec1;

  background: #eef7fb; /* 👈 más elegante que blue-50 */
  border: 1px solid #d9eef5;

  transition: all 0.2s ease;
}

/* HOVER */
.tag-badge:hover {
  background: #4d9ec1;
  color: #fff;
  border-color: #4d9ec1;
}

</style>